export const SPECIAL_ADMIN_EMAILS = [
  "rem@premierlive.com", 
  "rem@goexchange.ai"
].map(email => email.toLowerCase());

export const PROTECTED_ROUTES = [
  '/dashboard',
  '/admin',
  '/admin/users',
  '/admin/enhanced',
  '/admin/roles',
  '/admin/shortcuts',
  '/admin/shortcuts-manager',
  '/admin/company-linking',
  '/admin/base-assignments',
];

export const PUBLIC_ROUTES = [
  '/',
  '/auth',
  '/auth/login',
  '/auth/register',
  '/auth/forgot-password',
  '/auth/reset-password',
];
